<template>
  <form @submit.prevent="handleSubmit(item)" novalidate>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.name) }">
      <label for="_name" class="control-label">Nazwa klienta</label>
      <input v-model="item.name" type="text" id="_name" class="form-control" />
      <span v-if="errors && errors.name" class="help-block" id="_name_helpBlock">{{ errors.name }}</span>
    </div>
	<div class="row form-group">
		<div :class="{ 'form-group col-lg-6': true, 'has-error': (errors && errors.nip) }">
		<label for="_nip" class="control-label">NIP</label>
		<input v-model="item.nip" type="text" id="_nip" class="form-control" />
		<span v-if="errors && errors.nip" class="help-block" id="_nip_helpBlock">{{ errors.nip }}</span>
		</div>
		<div :class="{ 'form-group col-lg-6': true, 'has-error': (errors && errors.regon) }">
		<label for="_regon" class="control-label">REGON</label>
		<input v-model="item.regon" type="text" id="_regon" class="form-control" />
		<span v-if="errors && errors.regon" class="help-block" id="_regon_helpBlock">{{ errors.regon }}</span>
		</div>
	</div>
	<div class="row form-group">
		<div :class="{ 'form-group col-lg-6': true, 'has-error': (errors && errors.pesel) }">
		<label for="_pesel" class="control-label">PESEL</label>
		<input v-model="item.pesel" type="text" id="_pesel" class="form-control" />
		<span v-if="errors && errors.pesel" class="help-block" id="_pesel_helpBlock">{{ errors.pesel }}</span>
		</div>
		<div :class="{ 'form-group col-lg-6': true, 'has-error': (errors && errors.krs) }">
			<label for="_krs" class="control-label">KRS</label>
			<input v-model="item.krs" type="text" id="_pesel" class="form-control" />
			<span v-if="errors && errors.krs" class="help-block" id="_pesel_helpBlock">{{ errors.krs }}</span>
		</div>
	</div>
	<div class="row form-group">
		<div :class="{ 'form-group col-lg-12': true, 'has-error': (errors && errors.commission) }">
		<label for="_commission" class="control-label">Prowizja</label>
			<b-input-group right="%">
				<b-form-input v-model="item.commission" type="text" id="_commission"></b-form-input>
			</b-input-group>
		<span v-if="errors && errors.commission" class="help-block" id="_commission_helpBlock">{{ errors.commission }}</span>
		</div>
	</div>
	<div class="row form-group">
		<div :class="{ 'form-group col-lg-8': true, 'has-error': (errors && errors.address && errors.address.street) }">
		<label for="_address_street" class="control-label">Ulica</label>
		<input v-model="item.address.street" type="text" id="_address_street" class="form-control" />
		<span v-if="errors && errors.address && errors.address.street" class="help-block" id="_address_street_helpBlock">{{ errors.address.street }}</span>
		</div>
		<div :class="{ 'form-group col-lg-4': true, 'has-error': (errors && errors.address && errors.address.number) }">
		<label for="_address_number" class="control-label">Numer domu</label>
		<input v-model="item.address.number" type="text" id="_address_number" class="form-control" />
		<span v-if="errors && errors.address && errors.address.number" class="help-block" id="_address_number_helpBlock">{{ errors.address.number }}</span>
		</div>
	</div>
	<div class="row form-group">
		<div :class="{ 'form-group col-lg-4': true, 'has-error': (errors && errors.address && errors.address.postalCode) }">
		<label for="_address_postalCode" class="control-label">Kod pocztowy</label>
		<input v-model="item.address.postalCode" type="text" id="_address_postalCode" class="form-control" />
		<span v-if="errors && errors.address && errors.address.postalCode" class="help-block" id="_address_postalCode_helpBlock">{{ errors.address.postalCode }}</span>
		</div>
		<div :class="{ 'form-group col-lg-8': true, 'has-error': (errors && errors.address && errors.address.city) }">
		<label for="_address_city" class="control-label">Miasto</label>
		<input v-model="item.address.city" type="text" id="_address_city" class="form-control" />
		<span v-if="errors && errors.address && errors.address.city" class="help-block" id="_address_city_helpBlock">{{ errors.address.city }}</span>
		</div>
	</div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.bankAccount && (errors.bankAccount.numberPLN || errors.bankAccount.bankAccountSet)) }">
      <label for="_bankAccount_numberPLN" class="control-label">Numer konta bankowego (PLN)</label>
      <input v-model="item.bankAccount.numberPLN" type="text" id="_bankAccount_numberPLN" class="form-control" />
      <span v-if="errors && errors.bankAccount && errors.bankAccount.numberPLN" class="help-block" id="_bankAccount_numberPLN_helpBlock">{{ errors.bankAccount.numberPLN }}</span>
      <span v-if="errors && errors.bankAccount && errors.bankAccount.bankAccountSet" class="help-block" id="_bankAccount_number_helpBlock">{{ errors.bankAccount.bankAccountSet }}</span>
    </div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.bankAccount && (errors.bankAccount.numberEUR || errors.bankAccount.bankAccountSet)) }">
      <label for="_bankAccount_numberEUR" class="control-label">Numer konta bankowego (EUR)</label>
      <input v-model="item.bankAccount.numberEUR" type="text" id="_bankAccount_numberEUR" class="form-control" />
      <span v-if="errors && errors.bankAccount && errors.bankAccount.numberEUR" class="help-block" id="_bankAccount_numberEUR_helpBlock">{{ errors.bankAccount.numberEUR }}</span>
      <span v-if="errors && errors.bankAccount && errors.bankAccount.bankAccountSet" class="help-block" id="_bankAccount_number2_helpBlock">{{ errors.bankAccount.bankAccountSet }}</span>
    </div>
	<div class="row form-group">
		<div :class="{ 'form-group col-lg-6': true, 'has-error': (errors && errors.contact && errors.contact.email) }">
		<label for="_contact_email" class="control-label">E-mail</label>
		<input v-model="item.contact.email" type="text" id="_contact_email" class="form-control" />
		<span v-if="errors && errors.contact && errors.contact.email" class="help-block" id="_contact_email_helpBlock">{{ errors.contact.email }}</span>
		</div>
			<div :class="{ 'form-group col-lg-6': true, 'has-error': (errors && errors.contact && errors.contact.phone) }">
		<label for="_contact_phone" class="control-label">Numer telefonu</label>
		<input v-model="item.contact.phone" type="text" id="_contact_phone" class="form-control" />
		<span v-if="errors && errors.contact && errors.contact.phone" class="help-block" id="_contact_phone_helpBlock">{{ errors.contact.phone }}</span>
		</div>
	</div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.comments) }">
      <label for="_comments" class="control-label">Uwagi</label>
      <textarea v-model="item.comments" id="_comments" class="form-control"></textarea>
      <span v-if="errors && errors.comments" class="help-block" id="_comments_helpBlock">{{ errors.comments }}</span>
    </div>

    <router-link :to="{ name: 'CustomerList' }" class="btn btn-primary"><span>Powrót</span><svg-icon name="back"/></router-link>
    <my-button text="Zapisz" icon="tick" type="submit"/>
  </form>
</template>

<script>
  export default {
    props: {
      handleSubmit: {
        type: Function,
        required: true,
      },
      values: {
        type: Object,
        required: true
      },
      errors: {
        type: Object
      },
      initialValues: {
        type: Object
      }
    },
    computed: {
      item: function () {
        return this.initialValues ? this.initialValues : this.values;
      }
    },
    watch:{
      'item.commission': function (newValue) {
        if(newValue.indexOf(",") !== false ){
          this.item.commission= newValue.replace(/,/g, '.');
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Form.vue?5bea8f0c